"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CallbackTypes = _interopRequireWildcard(require("../constants/CallbackTypes"));
var _ViewMode = require("../constants/ViewMode");
var _UIActionConstants = require("../constants/UIActionConstants");
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _Enums = require("../constants/Enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/* eslint class-methods-use-this: 0 */

class ValidationService {
  constructor(isViewSDKPublic = false) {
    this._isViewSDKPublic = isViewSDKPublic;
    this._configKeysAndValidators = {
      preset: this._validatePreset,
      embedMode: this._validatePreset,
      showAnnotationTools: this._validateBooleanValue,
      enableAnnotationAPIs: this._validateBooleanValue,
      includePDFAnnotations: this._validateBooleanValue,
      showLeftHandPanel: this._validateBooleanValue,
      showPageControls: this._validateBooleanValue,
      dockPageControls: this._validateBooleanValue,
      showDownloadPDF: this._validateBooleanValue,
      showPrintPDF: this._validateBooleanValue,
      showFitPageButton: this._validateBooleanValue,
      annotationUIConfig: this._validateAnnotationUIConfig,
      showFitWidthButton: this._validateBooleanValue,
      showZoomControl: this._validateBooleanValue,
      showRotateViewControl: this._validateBooleanValue,
      showPageNavigationControl: this._validateBooleanValue,
      enableFormFilling: this._validateBooleanValue,
      defaultViewMode: this._validateStringValue,
      supportUrl: this._validateStringValue,
      integrationName: this._validateStringValue,
      backgroundColor: this._validateStringValue,
      enableLinearization: this._validateBooleanValue,
      enableEdit: this._validateBooleanValue,
      usePartialEdit: this._validateBooleanValue,
      usePremiumIndicator: this._validateBooleanValue,
      isDemoMode: this._validateBooleanValue,
      showEditOnTextSelection: this._validateBooleanValue,
      shouldEnableEditGenAI: this._validateBooleanValue,
      showAdvancedFontPicker: this._validateBooleanValue,
      enableNumberPages: this._validateBooleanValue,
      enableCropPages: this._validateBooleanValue,
      useIframelessPrint: this._validateBooleanValue,
      enableInlineOrganize: this._validateBooleanValue,
      disableProtectedPDFCancelButton: this._validateBooleanValue,
      printStrategy: this._validatePrintStrategy,
      defaultRHPFeature: this._validateStringValue,
      showBookmarks: this._validateBooleanValue,
      showThumbnails: this._validateBooleanValue,
      enableModernViewer: this._validateBooleanValue,
      enableReadAloud: this._validateBooleanValue,
      showTopBar: this._validateBooleanValue,
      showBranding: this._validateBooleanValue,
      showLegalNotice: this._validateBooleanValue,
      exitPDFViewerType: this._validateExitPDFViewerType,
      enableEditForFreeUsers: this._validateBooleanValue,
      disableEditFeatures: this._validateObjectValue
    };
  }
  _validateExitPDFViewerType(key, value) {
    let err;
    if (value !== _ViewMode.LightBoxExitPDFViewerType.RETURN && value !== _ViewMode.LightBoxExitPDFViewerType.CLOSE) {
      err = new Error(`Only "RETURN" or "CLOSE" input is supported for config ${key}`);
    }
    return err;
  }
  _validatePrintStrategy(key, value) {
    let err;
    if (!Object.values(_Enums.printStrategy).includes(value)) {
      err = new Error(`Only "preferBrowserOverHTMLPrint", "useBrowserOnly" and 
            "useIntegrationPrint" is allowed for config ${key}`);
    }
    return err;
  }
  _validateStringValue(key, value) {
    let err;
    if (typeof value !== "string") {
      err = new Error(`Only String input is supported for config ${key}`);
    }
    return err;
  }
  _validateBooleanValue(key, value) {
    let err;
    if (typeof value !== "boolean") {
      err = new Error(`Only Boolean input is supported for config ${key}`);
    }
    return err;
  }
  _validateObjectValue(key, value) {
    let err;
    if (typeof value !== "object" || value === null || Array.isArray(value)) {
      err = new Error(`Only non-null objects are supported for config ${key}`);
    }
    return err;
  }
  _validatePreset(key, value) {
    let err;
    if (value) {
      switch (value) {
        case _ViewMode.Preset.FULL_WINDOW:
        case _ViewMode.Preset.SIZED_CONTAINER:
        case _ViewMode.Preset.IN_LINE:
        case _ViewMode.Preset.LIGHT_BOX:
        case "INTEGRATION":
          break;
        default:
          err = new Error(`Please pass valid embed mode. Currently, only "FULL_WINDOW", "SIZED_CONTAINER",
                "IN_LINE" and "LIGHT_BOX" embed modes are supported`);
      }
    }
    return err;
  }
  _validateAnnotationUIConfig(key, value = {}) {
    let err;
    if (Object.keys(value).filter(val => typeof value[val] !== "boolean").length > 0) {
      err = new Error(`Only Boolean input is supported for config ${key}`);
    }
    return err;
  }

  /**
   * Validates incoming config.
   * 1. Only clientId is mandatory.
   * 2. Invalid value of divId isn't allowed
   */
  validateConfig(config) {
    if (!config) {
      throw new Error("Invalid config is provided.");
    }
    if (!config.clientId) {
      throw new Error("Invalid client id is provided.");
    }
    if ("divId" in config && !config.divId) {
      throw new Error("Invalid div id is provided.");
    }
  }

  /**
   * Validates data type of previewConfig entries
   */
  validatePreviewConfig(previewConfig) {
    let err;
    if (previewConfig) {
      Object.keys(previewConfig).forEach(key => {
        if (this._configKeysAndValidators[key]) {
          err = this._configKeysAndValidators[key](key, previewConfig[key]);
          if (err) {
            throw err;
          }
        }
      });
    }
  }

  /**
   * Validates file info object based on Preview Config.
   */
  validateFileInfoForPreviewConfig(fileInfo, previewConfig) {
    if (previewConfig.enableAnnotationAPIs && fileInfo.metaData && !fileInfo.metaData.id) {
      throw new Error("File id is missing in file information metaData.");
    }
    if (previewConfig.enableLinearization) {
      this.validateContentLinearizationInfo(fileInfo);
    }
  }

  /**
   * Validates file info object.
   * 1. It should contain a valid content object.
   */
  validateFileInfo(fileInfo) {
    if (this._isViewSDKPublic && (!fileInfo || !fileInfo.content && !fileInfo.rendition)) {
      throw new Error("Missing content in file information.");
    }
    if (fileInfo.content) {
      this._validateFileInfoContent(fileInfo.content);
    }
    if (this._isViewSDKPublic) {
      if (!fileInfo.metaData) {
        throw new Error("Missing metaData in file information.");
      }
      this._validateFileInfoMetaData(fileInfo.metaData);
    }
    if (fileInfo.rendition) {
      Object.keys(fileInfo.rendition).forEach(pageIndex => {
        this._validateFileInfoContent(fileInfo.rendition[pageIndex]);
      });
    }
  }

  /**
   * Validates file info meta data object.
   * 1. Only fileName is mandatory.
   */
  _validateFileInfoMetaData(metaData) {
    if (!metaData.fileName) {
      throw new Error("File name is missing in file information metaData.");
    }
  }

  /**
   * Validate that provided mime type is present and its not a PDF
   */
  validateNonPDFMimeType(mimeType) {
    if (!mimeType || mimeType.toLowerCase() === "application/pdf") {
      throw new Error("Only non PDF mime type is supported");
    }
  }

  /**
   * @method
   * @description
   * Validates Callback Registration and Callback options update
   *
   * @param {string} type - type of callback
   * @param {function} callback - callback function
   * @param {Object} options - callback options
   */
  validateCallback(type, callback, options) {
    if (typeof callback !== "function") {
      throw new Error("Callback should be of Function type");
    }
    const keys = Object.keys(options);
    switch (type) {
      case _CallbackTypes.default.SAVE_API:
        keys.forEach(key => {
          if (["incremental", "showError", "showSaveButton", "showEditStatusInfo"].indexOf(key) !== -1 && typeof options[key] !== "boolean") {
            throw new Error(`${key} value should be of boolean type`);
          }
          if (["autoSaveFrequency"].indexOf(key) !== -1 && typeof options[key] !== "number") {
            throw new Error(`${key} value should be of number type`);
          }
        });
        break;
      case _CallbackTypes.default.STATUS_API:
        keys.forEach(key => {
          if (["filePollFrequency", "autoSaveFrequency"].indexOf(key) !== -1 && typeof options[key] !== "number") {
            throw new Error(`${key} value should be of number type`);
          }
          if (["enableFocusPolling"].indexOf(key) !== -1 && typeof options[key] !== "boolean") {
            throw new Error(`${key} value should be of boolean type`);
          }
        });
        break;
      case _CallbackTypes.default.EVENT_LISTENER:
      case _CallbackTypes.default.SET_USER_SETTING_API:
      case _CallbackTypes.default.GET_USER_SETTING_API:
      case _CallbackTypes.default.GET_USER_PROFILE_API:
      case _CallbackTypes.default.OPEN_LEGAL_DIALOG_API:
      case _CallbackTypes.default.GET_FEATURE_FLAG:
      case _CallbackTypes.default.GET_LOCAL_FONT_PRIMING_DIALOG:
      case _CallbackTypes.default.GET_USER_THEME_PREF:
      case _CallbackTypes.default.GET_RENDITION_API:
      case _CallbackTypes.default.GET_FILE_BUFFER_RANGES:
      case _CallbackTypes.default.GET_PUBLIC_PDF_URL:
      case _CallbackTypes.default.GET_INSERT_FILE_BUFFER:
      case _CallbackTypes.default.GET_IMAGE_BUFFER:
      case _CallbackTypes.default.EDIT_EVENT_HANDLER:
      case _CallbackTypes.default.GET_FILE_PATH:
      case _CallbackTypes.default.GET_SUGGESTION_LIST_API:
      case _CallbackTypes.default.GET_VIEWER_ANALYTICS:
      case _CallbackTypes.default.GET_ASSET_VERSION:
      case _CallbackTypes.default.WAIT_FOR_DOC_SAVE_COMPLETION:
        break;
      default:
        throw new Error(`Callback type ${type} not supported`);
    }
  }

  /**
   * Validates file info content object.
   * 1. Either it should have local data promise or location url.
   */
  _validateFileInfoContent(content) {
    if (!content.promise && !content.location) {
      throw new Error("Invalid content information is provided.");
    }
    if (content.location && !content.location.url) {
      throw new Error("Invalid content information is provided.");
    }
  }

  /**
   * Validates custom UI Icon config entries
   */
  validateUIActionConfig(uiActionConfig) {
    // TODO Throw error once UI action goes public

    if (!uiActionConfig) {
      return false;
    }
    if (uiActionConfig.length <= 0) {
      return false;
    }
    let typeValidation = false;
    let positionValidation = false;
    let iconTypeValidation = false;
    let onClickFunctionValidation = false;
    uiActionConfig.forEach(config => {
      typeValidation = typeof config === "object";
      positionValidation = Object.keys(_UIActionConstants.UIActionPositionTypes).map(e => _UIActionConstants.UIActionPositionTypes[e]).some(value => value === config.position);
      iconTypeValidation = Object.keys(_UIActionConstants.UIActionIconTypes).map(e => _UIActionConstants.UIActionIconTypes[e]).some(value => value === config.iconType);
      onClickFunctionValidation = typeof config.onClick === "function";
    });
    return typeValidation && positionValidation && iconTypeValidation && onClickFunctionValidation;
  }

  /**
   * Validates linearization info object in content.
   */
  validateContentLinearizationInfo(fileInfo) {
    const content = fileInfo.content;
    const linearizationInfo = content.linearizationInfo;
    if (!content.location && !linearizationInfo) {
      throw new Error("Invalid content linearization information is provided.");
    }
    if (linearizationInfo) {
      if (!linearizationInfo.getInfo || typeof linearizationInfo.getInfo !== "function" || !linearizationInfo.getInitialBuffer || typeof linearizationInfo.getInitialBuffer !== "function" || !linearizationInfo.getFileBufferRanges || typeof linearizationInfo.getFileBufferRanges !== "function") {
        throw new Error("Invalid content linearization information is provided.");
      }
    }
  }

  /**
   * Validates open edit based prerequisites
   */
  validateOpenEditConfig() {
    let openEditFlag = true;
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const callbackService = _ServiceRegistry.default.getService("CallbackService");
    let eventType = "";
    if (!appStore.isEditEnabled) {
      openEditFlag = false;
      eventType = _CallbackTypes.EditEventTypes.EDIT_MODE_DISABLED;
    } else if (!appStore.isUserSignedIn) {
      openEditFlag = false;
      eventType = _CallbackTypes.EditEventTypes.USER_NOT_LOGGED_IN;
    } else if (!appStore.enableModernViewer) {
      openEditFlag = false;
      eventType = _CallbackTypes.EditEventTypes.MODERN_VIEWER_DISABLED;
    }
    if (!openEditFlag && callbackService.hasCallback(_CallbackTypes.default.EDIT_EVENT_HANDLER)) {
      const callbackFn = callbackService.getCallback(_CallbackTypes.default.EDIT_EVENT_HANDLER);
      callbackFn(eventType);
    }
    return openEditFlag;
  }
}
exports.default = ValidationService;